import { courseConstants } from "../constants/courses";

const initialState = {
  courses: [],
  getCourseFailure: false,
  fetchingCourse: false,
  courseStatus: false,
  fetchingCourseSubcourses: false,
  subcourses: [],
  sections:[],
  lessons:[],
  subcourseSections: {},
  sectionLessons: {}
};


export function courses (state = initialState, action){
    switch(action.type) {
        case courseConstants.GET_COURSE_FAILURE:
            return {
                ...state,
                getCourseFailure : true,
                fetchingCourse: false,
                courseFetchError : action.error
            }
        case courseConstants.GET_COURSE_REQUEST:
            return {
                ...state,
                fetchingCourse : true,
            }
        case courseConstants.GET_COURSE_SUCCESS:
            return {
                ...state,
                fetchingCourse: false,
                course: action.course
            }
        case courseConstants.TOGGLE_COURSE_STATUS_REQUEST:
            return {
                ...state,
                courseStatus : true,
            }
        case courseConstants.TOGGLE_COURSE_STATUS_SUCCESS:
            return {
                ...state,
                courseStatus : false,
            }   
        case courseConstants.TOGGLE_COURSE_STATUS_FAILURE:
            return {
                ...state,
                courseStatus : false,
                error : action.error
            }  
        case courseConstants.GET_COURSE_SUBCOURSES_FAILURE:
            return {
                ...state,
                fetchingCourseSubcourses: false,
                subcourseFetchError : action.error
            }
        case courseConstants.GET_COURSE_SUBCOURSES_REQUEST:
            return {
                ...state,
                fetchingCourseSubcourses : true,
            }
        case courseConstants.GET_COURSE_SUBCOURSES_SUCCESS:
            return {
                ...state,
                fetchingCourseSubcourses: false,
                subcourses: action.subcourses
            }   
        case courseConstants.CREATE_SUBCOURSE_FAILURE:
            return {
                ...state,
                creatingSubcourse: false,
            }    
        case courseConstants.CREATE_SUBCOURSE_REQUEST:
            return {
                ...state,
                creatingSubcourse: true,
            }
        case courseConstants.CREATE_SUBCOURSE_SUCCESS:
            return {
                ...state,
                subcourse : action.subcourse,
                creatingSubcourse: false,
            }
        case courseConstants.GET_COURSES_REQUEST:
            return {
              ...state,
              fetchingCourse: true
            };
        case courseConstants.GET_COURSES_SUCCESS:
            return {
              ...state,
              fetchingCourse: false,
              courses: action.courses
            };
        case courseConstants.GET_COURSES_FAILURE:
            return {
              ...state,
              fetchingCourse: false,
              error: action.error
            };
        case courseConstants.UPDATE_INDEX_SUBCOURSE_SUCCESS:
            return {
                ...state,
                subcourseIndexes : action.subcourse
            }
            case courseConstants.TOGGLE_SUBCOURSE_STATUS_REQUEST:
            return {
              ...state,
              togglePublishStatus: true
            };
        case courseConstants.TOGGLE_SUBCOURSE_STATUS_SUCCESS:
            state.subcourses.forEach(subcourse => { if(subcourse.id === action.subcourse.subcourseId) subcourse.published = action.subcourse.status  })
            return {
              ...state,
              togglePublishStatus: false,
            
            };
        case courseConstants.TOGGLE_SUBCOURSE_STATUS_FAILURE:
            return {
              ...state,
              togglePublishStatus: false,
              error: action.error
            };    
        case courseConstants.CREATE_SECTION_FAILURE:
            return {
                ...state,
                creatingSection: false,
            }    
        case courseConstants.CREATE_SECTION_REQUEST:
            return {
                ...state,
                creatingSection: true,
            }
        case courseConstants.CREATE_SECTION_SUCCESS:
            return {
                ...state,
                createdSection : {
                [(action.section.subcourseId ? action.section.subcourseId : 'createdSection')] : action.section },
                creatingSection: false,
            } 
        case courseConstants.GET_SECTION_FAILURE:
            return {
                ...state,
                fetchingSection: false,
            }    
        case courseConstants.GET_SECTION_REQUEST:
            return {
                ...state,
                fetchingSection: true,
            }
        case courseConstants.GET_SECTION_SUCCESS:
            return {
                ...state,
                subcourseSections : {
                    ...state.subcourseSections, 
                    [(action.section.length > 0 ? action.section[0].subcourseId : 'subcourseSection')] : action.section },
                fetchingSection: false,
            }     

        case courseConstants.GET_LESSON_FAILURE:
            return {
                ...state,
                fetchingLesson: false,
            }    
        case courseConstants.GET_LESSON_REQUEST:
            return {
                ...state,
                fetchingLesson: true,
            }
        case courseConstants.GET_LESSON_SUCCESS:
            return {
                ...state,
                sectionLessons : {
                ...state.sectionLessons, 
                [(action.lesson.length > 0 ? action.lesson[0].sectionId : 'subcourseSection')] : action.lesson },
                fetchingLesson: false,
            }


        case courseConstants.CREATE_LESSON_FAILURE:
            return {
                ...state,
                creatingLesson: false,
            }    
        case courseConstants.CREATE_LESSON_REQUEST:
            return {
                ...state,
                creatingLesson: true,
            }
        case courseConstants.CREATE_LESSON_SUCCESS:
            return {
                ...state,
                createdLesson : action.lesson ,
                creatingLesson: false,
            }

        
        case courseConstants.SET_NODE_FAILURE:
            return {
                ...state,
                setNode: false,
            }    
        case courseConstants.SET_NODE_REQUEST:
            return {
                ...state,
                setNode: true,
            }
        case courseConstants.SET_NODE_SUCCESS:
            return {
                ...state,
                setNode: false,
            }    

        
        case courseConstants.DELETE_SUBCOURSE_FAILURE: 
            return {
                ...state,
                deletingSubcourse: false
            }
        case courseConstants.DELETE_SUBCOURSE_SUCCESS:        
            let subcourse = state.subcourses.filter(subcourse => { if(subcourse.id !== action.subcourse){ return subcourse }  })     
            return {
                ...state,
                deletingSubcourse: false,
                subcourses: subcourse
            }
        case courseConstants.DELETE_SUBCOURSE_REQUEST:        
            return {
                ...state,
                deletingSubcourse: true
            }

        case courseConstants.DELETE_SECTION_FAILURE: 
             return {
                ...state,
                deletingSection: false,
            }
        case courseConstants.DELETE_SECTION_SUCCESS:   
            let section = state.subcourseSections[action.section.subcourseId].filter(section => (section.id !== action.section.sectionId))     
            return {
                ...state,
                deletingSection: false,
                subcourseSections : {
                    [action.section.subcourseId] : section 
                }
            }
        case courseConstants.DELETE_SECTION_REQUEST:        
            return {
                ...state,
                deletingSection: true
            }
        case courseConstants.DELETE_LESSON_FAILURE: 
            return {
                ...state,
                deletingLesson: false
            }
        case courseConstants.DELETE_LESSON_SUCCESS:       
            let lesson = state.sectionLessons[action.lesson.sectionId].filter(lesson => (lesson.id !== action.lesson.lessonId))     
            return {
                ...state,
                deletingLesson: false,
                sectionLessons : {
                    [action.lesson.sectionId] : lesson 
                }
            }
        case courseConstants.DELETE_LESSON_REQUEST:        
            return {
                ...state,
                deletingLesson: true
            }
        case courseConstants.TOGGLE_SECTION_STATUS_REQUEST:
            return {
              ...state,
              togglePublishStatus: true
            };
        case courseConstants.TOGGLE_SECTION_STATUS_SUCCESS:
            state.subcourseSections[action.section['section'].subcourseId].map(section => {
                if (section.id === action.section['section'].id){
                    return section.published = action.section.status
                } else { return } 
            })
            return {
              ...state,
              togglePublishStatus: false,
           
            
            };
        case courseConstants.TOGGLE_SECTION_STATUS_FAILURE:
            return {
              ...state,
              togglePublishStatus: false,
              error: action.error
            };           


        default:
           return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/courses.js